export enum OrderDocumentType {
  INVOICE = 'invoice',
  CREDITNOTE = 'creditNote'
}
